import React from 'react';

function CommentIcon({active}) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.5 6.16634C4.5 4.32539 5.99238 2.83301 7.83333 2.83301H14.786C15.67 2.83301 16.5179 3.1842 17.143 3.80932L18.5237 5.19003C19.1488 5.81515 19.5 6.663 19.5 7.54705V17.833C19.5 19.674 18.0076 21.1663 16.1667 21.1663H7.83333C5.99238 21.1663 4.5 19.674 4.5 17.833V6.16634ZM17.8333 8.66634V17.833C17.8333 18.7535 17.0871 19.4997 16.1667 19.4997H7.83333C6.91286 19.4997 6.16667 18.7535 6.16667 17.833V6.16634C6.16667 5.24587 6.91286 4.49967 7.83333 4.49967H13.6667V6.16634C13.6667 7.54705 14.786 8.66634 16.1667 8.66634H17.8333ZM17.7409 6.99967C17.659 6.76434 17.5247 6.54807 17.3452 6.36854L15.9645 4.98783C15.7849 4.8083 15.5687 4.67396 15.3333 4.59212V6.16634C15.3333 6.62658 15.7064 6.99967 16.1667 6.99967H17.7409Z'
        fill={active ? `#DF9800` : `#999999`}
      />
      <path
        d='M11.9998 9.5C11.5396 9.5 11.1665 9.8731 11.1665 10.3333V13.6667C11.1665 14.1269 11.5396 14.5 11.9998 14.5C12.4601 14.5 12.8332 14.1269 12.8332 13.6667V10.3333C12.8332 9.8731 12.4601 9.5 11.9998 9.5Z'
        fill={active ? `#DF9800` : `#999999`}
      />
      <path
        d='M11.9998 15.3333C11.5396 15.3333 11.1665 15.7064 11.1665 16.1667C11.1665 16.6269 11.5396 17 11.9998 17C12.4601 17 12.8332 16.6269 12.8332 16.1667C12.8332 15.7064 12.4601 15.3333 11.9998 15.3333Z'
        fill={active ? `#DF9800` : `#999999`}
      />
    </svg>
  );
}

export default CommentIcon;
